<template mlns="http://www.w3.org/1999/html">
  <div style="font-family: PingFangSC-Regular, 微软雅黑;" v-loading="initLoading">
    <div style="padding: 20px;position: relative">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/PackageExplorer' }">资源包管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="font-size: 25px;margin-top: 10px;">
        <p>资源包管理</p>
      </div>

      <div style="width: 100%; font-size: 25px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="100px"
                 style="margin-top: 10px;width: 300px">
          <el-form-item label="供应商" prop="supplierId">
            <el-select popper-class="el-select" v-model="ruleForm.supplierId" value-key="id" placeholder="请选择供应商"
                       style="width: 400px">
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select popper-class="el-select" v-model="ruleForm.status" multiple clearable value-key="value"
                       placeholder="请选择状态,不筛选则查看全部"
                       style="width: 400px">
              <select-all-option v-model="ruleForm.status" :data="statusList"/>
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value='item'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              class="button" :loading="loading" @click="queryData('ruleForm')">确定
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative">
        <el-table
          :data="tableData"
          id="tableData"
          height="500"
          style="margin-top: 20px;width: 100%; color: #979797;"
          border>
          <el-table-column
            prop="id"
            align="center"
            label="资源包序列号">
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="资源包名称">
          </el-table-column>
          <el-table-column
            prop="type"
            align="center"
            label="可抵扣的资源类型">
          </el-table-column>
          <el-table-column
            align="center"
            width="240px"
            label="起止时间">
            <template slot-scope="scope">
              <div>{{
                  tableData[scope.$index].effectiveTime + ' 至 ' + tableData[scope.$index].failureTime
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="300px"
            label="状态">
            <template slot-scope="scope">
              <div>
                <div style="display: flex;">
                  <div class="font-style1">总量：{{ tableData[scope.$index].useNumber }} 件</div>
                  <div style="flex: 1"></div>
                  <div style="font-size: 15px;line-height: 17px;letter-spacing: -0.02em;color: #ED7043;">
                    {{ tableData[scope.$index].status ? '生效中' : '已失效' }}
                  </div>
                </div>

                <el-progress :percentage="tableData[scope.$index].usedNumber / tableData[scope.$index].useNumber * 100"
                             :show-text="false" :color="'#D8D8D8'"></el-progress>

                <div style="display: flex;">
                  <div class="font-style1">已用：{{ tableData[scope.$index].usedNumber }} 件</div>
                  <div style="flex: 1"></div>
                  <div class="font-style1">余额：<span
                    style="color: #ED7043;">{{
                      tableData[scope.$index].useNumber - tableData[scope.$index].usedNumber
                    }}</span>
                    件
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="entity"
            width="150px"
            label="资源包详情">
            <template slot-scope="scope">
              <el-button @click="checkBundleDetail(scope.$index)" type="text" size="small" style="color: #008AFF;">
                查看详情
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="company"
            width="150px"
            label="消耗明细">
            <template slot-scope="scope">
              <el-button @click="checkDetail(scope.$index)" type="text" size="small" style="color: #008AFF;">查看明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="资源包订单详情"
      :visible.sync="dialogVisible"
      width="50%">
      <div
        style="text-align: center; font-weight: 600;font-size: 20px;line-height: 28px;letter-spacing: -0.02em;color: #000000;">
        资源包名称：{{ dialogTitle }}
      </div>
      <div>
        <el-table
          class="bundleDetail"
          :show-header="false"
          :data="dialogTableData"
          border
          style="width: 100%; color: #979797; "
        >
          <el-table-column prop="key" min-width="25px" align="right"></el-table-column>
          <el-table-column prop="value" align="left"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="button" @click="dialogVisible = false">返回</el-button>
     </span>
    </el-dialog>

    <el-dialog
      title="资源包抵扣明细"
      :visible.sync="dialogVisible1"
      width="50%">

      <el-table
        :data="dialogTableData"
        border
        style="width: 100%; color: #979797;">
        <el-table-column
          prop="zdMonth"
          align="center"
          label="计费月份">
        </el-table-column>
        <el-table-column
          prop="deductTime"
          align="center"
          label="扣除时间">
        </el-table-column>
        <el-table-column
          prop="type"
          align="center"
          label="抵扣资源类型">
        </el-table-column>
        <el-table-column
          prop="share"
          align="center"
          label="共享成员">
        </el-table-column>
        <el-table-column
          prop="usedNumber"
          align="center"
          label="消耗量(次)">
        </el-table-column>
        <el-table-column
          prop="remainingNumber"
          align="center"
          label="余量(次)">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer1">
        <el-button class="button" @click="dialogVisible1 = false">返回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {getSupplierList, getBundle} from "@/api/PackageExplorer"
import selectAllOption from "@/components/selectAllOption";

export default {
  name: "PackageExplorer",
  components: {selectAllOption},
  data() {
    return {
      token: '',
      loading: false,
      initLoading: true,
      dialogVisible: false,
      dialogVisible1: false,
      rules: {
        supplierId: [
          {required: true, message: '请至少选择一个供应商', trigger: 'change'}
        ]
      },

      supplierList: [],
      statusList: [
        {
          label: '生效中',
          value: 1
        }, {
          label: '已失效',
          value: 0
        }
      ],
      ruleForm: {
        supplierId: '',
        status: []
      },
      tableData: [],
      dialogTableData: [],
      dialogTitle: '',
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    this.initLoading = true;
    getSupplierList(this.token).then(res => {
      if (res.data.code == 200) {
        this.supplierList = res.data.date
        if (this.supplierList.length == 1) {
          this.ruleForm.supplierId = this.supplierList[0].id;
        }
      }
      this.initLoading = false;
    }).catch(error => {
      let status = error.response.status;
      if (status == 500) {
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    queryData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var dataList = {
            supplierId: this.ruleForm.supplierId, status: ''
          };

          if (this.ruleForm.status.length !== 2 && this.ruleForm.status.length !== 0)
            dataList.status = this.ruleForm.status[0].value

          this.loading = true;
          getBundle(this.token, dataList).then(res => {
            if (res.data.code == 200) {
              this.$notify.success({
                title: '成功',
                message: '查询成功',
                position: 'bottom-right'
              })
              this.tableData = res.data.date
            }
          }).catch(error => {
            let status = error.response.status;
            if (status == 500) {
              this.$notify.error({
                title: '错误',
                message: '查询失败，请联系管理员',
                position: 'bottom-right'
              })
            }
          }).finally(() => this.loading = false)
        }
      });
    },
    checkBundleDetail(index) {
      this.dialogTableData = this.tableData[index].maps1;
      this.dialogTitle = this.tableData[index].name;
      this.dialogVisible = true;
    },
    checkDetail(index) {
      this.dialogTableData = this.tableData[index].maps2;
      this.dialogVisible1 = true;
    }
  }
}
</script>

<style scoped>

.font-style1 {
  font-size: 12px;
  line-height: 25px;
  letter-spacing: -0.02em;
  color: #979797;
}

>>> .el-progress-bar__outer {
  height: 6px;
  border-radius: 100px;
  background-color: #ED7043;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}

>>> .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: white;
}

>>> .el-dialog__header {
  padding: 20px 20px 10px;
  background-color: #df742c;
}

>>> .el-icon-close:before {
  content: "\E6DB";
  color: white;
  font-weight: 600;
}

.button {
  color: white !important;
  background: #ff6633 !important;
}

>>> .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

>>> .bundleDetail .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-right: 10px;
  white-space: break-spaces;
}

</style>
